export default {
  createDrawing: '新建绘图',
  editDrawing: '编辑绘图',
  whetherDelete: '是否删除',
  pleaseEnterTheRemark: '请输入备注',
  pleaseEnterTheSeqNo: '请输入序号',
  deleteDrawing: '此操作将永久删除该绘图',
  whetherContinue: '是否继续',
  deleteSuccess: '删除成功',
  cancelDelete: '已取消删除',
  pleaseEnterCorrectCode: '请输入正确格式的代码',
}
